






















































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import Typography from '@/components/common/elements/Typography.vue';
import Button from '@/components/common/elements/Button.vue';
import { Items } from '@/services/hexabase/types';

@Component({
  components: { SingleText, Typography, Button },
})
export default class BulkStatusActionDialog extends Vue {
  // ダイアログ開閉状態
  @Prop({ default: false })
  private dialog?: boolean;
  // ダイアログ内表示タイトル
  @Prop({ default: '' })
  private title!: string;
  // ダイアログ内表示テキスト
  @Prop({ default: '' })
  private bodyText!: string;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;
  // ダイアログ内ボタンをテキストに変更
  @Prop({ default: false })
  private isTextActionButton?: boolean;
  // ダイアログ内NGボタン文字
  @Prop({ default: 'キャンセル' })
  private buttonTextNG?: string;
  // ダイアログ内OKボタン文字
  @Prop({ default: '確認' })
  private buttonTextOK?: string;
  // ダイアログ内NGボタン文字色
  @Prop({ default: 'light' })
  private buttonColorNG?: string;
  // ダイアログ内OKボタン文字色
  @Prop({ default: 'primary' })
  private buttonColorOK?: string;
  // 一覧で選択されたアイテムデータ
  @Prop({ default: () => ([]) })
  private itemData?: Array<Items>;
  // ダイアログ内テーブルに表示するためのカラム
  @Prop({ default: () => ([]) })
  private colums?: Array<{[k: string]: string}>;
  // ダイアログ内に表示するステータスアクション
  @Prop({ default: () => ([]) })
  private actions?: Array<{[k: string]: string}>;
  // ステータスアクションを実行した後のAPIレスポンス
  @Prop({ default: () => ({}) })
  private apiResponse?: {[k: string]: any};
  // 外部からのメッセージ
  @Prop({ default: () => ({}) })
  private messageDefine?: {[k: string]: any};
  // アクションAPIに問い合わせ中に表示する「loading」フラグ
  private isLoading = false;
  // ダイアログ内表示切り分けプロパティ
  private status = 'noItems';
  private message = 'アイテムを選択してください';
  private errItemData: Array<Items> = [];

  /**
   * アイテム情報を監視し更新されたらダイアログ内表示を切り替える
   */
  @Watch('itemData')
  private itemWatcher(): void {
    if (this.itemData && this.itemData.length === 0) {
      this.status = 'noItems';
    } else if(this.itemData && this.itemData.length >= 2){
      const target = this.itemData![0].status_id;
      if (this.itemData.every(v => v.status_id === target)) {
        this.status = 'haveItems';
      } else {
        this.status = 'notMatch';
      }
    } else {
      this.status = 'haveItems';
    }
    this.getMessage();
  }

  /**
   * APIの返り値を受け取り完了・エラーメッセージを表示
   */
  @Watch('apiResponse')
  private apiResult(): void {
    this.isLoading = false;

    // ステータスが変更された際のエラー処理
    if (
      this.apiResponse !== undefined &&
      this.apiResponse.errors !== undefined &&
      Object.keys(this.apiResponse.errors).length > 0
    ) {
      this.status = 'apiError';
      const errorRecodes = this.apiResponse.errors;
      this.colums!.unshift({text: '', value: 'error_message', width: '30'});
      this.errItemData.push(...errorRecodes);

      const itemCount = this.itemData !== undefined ? this.itemData.length : 0 ;
      const errCount = this.errItemData.length;
      const successText = (itemCount - errCount) > 0 ? `${itemCount - errCount} 件の処理が完了しました。\n` : '' ;
      this.message = `${successText}下記 ${errCount} 件が処理に失敗しました。`;

    } else if (this.apiResponse && Object.keys(this.apiResponse!).length > 0) {
      this.status = 'apiSuccess';
      const count = this.itemData !== undefined ? this.itemData.length : 0 ;

      if (count > 0) {
        this.message = `${count} 件の処理が完了しました。`;
      } else {
        this.status = 'apiError';
        this.getMessage();
      }

    }

  }

  /**
   * 内部プロパティ変更
   */
  private getMessage(): void {
    if (this.messageDefine && this.messageDefine[this.status] !== undefined) this.message = this.messageDefine[this.status]
  }

  /**
   * ステータスアクションボタンを押下した際アクションIDを通知
   * loadingOverlayを表示
   * @param {any} - アクション情報
   */
  @Emit('getAction')
  private getAction(action: any): any {
    this.isLoading = true;
    return action;
  }

  /**
   * 親コンポーネントに押下したか否か通知する
   * @module addDetailsOpratipon
   * @return boolean - false
   */
  @Emit('confirmOpratipon')
  public confirmOpratipon(): boolean {
    return false;
  }

  /**
   * API後の「確認ボタン」を押下した旨を通知
   * 内部プロパティの
   * ・アイテム情報
   * ・ステータスアクション情報
   * ・状態情報
   * を初期化
   * @return boolean
   */
  @Emit('successOpratipon')   
  private successOpratipon(): boolean{
    this.status = 'noItems';
    this.message = '';
    // if (this.apiResponse !== undefined) this.apiResponse = {};
    // if (this.itemData !== undefined && this.itemData.length > 0) this.itemData.splice(0);
    // if (this.actions !== undefined && this.actions.length > 0) this.actions.splice(0);
    if (this.errItemData !== undefined && this.errItemData.length > 0) this.errItemData.splice(0);
    return true;
  }

  /**
   * API後の「確認ボタン」を押下した旨を通知
   * サクセス処理と同様の為、サクセス処理実行
   * @return void
   */
  private apiErrOpratipon(): void{
    this.successOpratipon();
  }
}
